<template>
  <div class="modal fade" id="generalDocumentsFolderModal" tabindex="-1" role="dialog" aria-labelledby="generalDocumentsFolderModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="generalDocumentsFolderModalLabel">Folder</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label class="custom-label">Folder Name</label>
            <div class="input-group mb-3">
              <input class="form-control" v-model="name">
              <template v-if="edit">
                <div class="input-group-append">
                  <button class="btn btn-outline-success" type="button" @click="updateFolder">Save</button>
                  <button class="btn btn-outline-primary" type="button" @click="reset">Cancel</button>
                </div>
              </template>
              <div class="input-group-append" v-else>
                <button class="btn btn-outline-primary" type="button" @click="createFolder">Create</button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3 text-center" v-for="folder in generalDocumentsFolders"
              style="margin-top: 1em; position: relative;"
            >
              <i class="fa fa-folder" style="font-size: 2rem;"></i>
              <br>
              {{ folder.name }} <span v-if="folder.documents.length">({{ folder.documents.length }})</span>
              <button type="button" class="btn btn-secondary btn-sm delete-folder"
                @click="deleteFolder(folder)"
              >
                <i class="fa fa-trash-alt"></i>
              </button>
              <button type="button" class="btn btn-warning btn-sm edit-folder"
                @click="editFolder(folder)"
              >
                <i class="fa fa-edit fa-sm"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-warning" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import axios from 'axios'

  export default {
    props: ['url'],
    data() {
      return {
        name: '',
        edit: false,
        folderToEdit: null,
      }
    },
    methods: {
      createFolder() {
        this.$store.dispatch('storeDocumentsFolder', {
          url: this.url,
          data: {
            folder: {
              name: this.name,
            },
          },
        }).then(() => {
          this.name = ''
          window.notification.success(`Folder has been created`, 'Success!')
        });
      },
      deleteFolder(folder) {
        if (confirm('Do you really want to delete this folder? All Pictures will be deleted as well.')) {
          this.$store.dispatch('deleteDocumentsFolder', {
            url: this.url,
            folder,
          })
        }
      },
      editFolder(folder) {
        this.edit = true
        this.name = folder.name
        this.folderToEdit = folder
      },
      updateFolder() {
        axios.put(`/api/document_folders/${this.folderToEdit.id}`, {'name': this.name}).then(({data}) => {
          this.folderToEdit.name = data.name
          this.reset()
        })
      },
      reset() {
        this.edit = false
        this.name = ''
        this.folderToEdit = null
      }
    },
    computed: {
      ...mapState(['generalDocumentsFolders']),
    },
    mounted() {
      $('#generalDocumentsFolderModal').on('show.bs.modal', () => {
        this.reset()
      })
    },
  }
</script>

<style lang="scss" scoped>
@import '~@/_variables.scss';

.fa-folder {
  font-size: 3em;
  color: $kodak-red;
}
.delete-folder {
  position: absolute;
  top: -8px;
  right: 0;
}
.edit-folder {
  position: absolute;
  top: 30px;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/GeneralDocumentsFolderModal.vue